import { useTranslation } from 'react-i18next';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { TagsMode } from '@/shared/types/analytics';

interface TagsModeSelectProps {
  value: TagsMode | undefined;
  onChange: (mode: TagsMode) => void;
}

/** Picks whether a conversation must carry all or any of the selected tags. */
export const TagsModeSelect = ({ value, onChange }: TagsModeSelectProps) => {
  const { t } = useTranslation();

  return (
    <div role="presentation" onMouseDown={(e) => e.stopPropagation()}>
      <Select value={value ?? 'any'} onValueChange={(mode) => onChange(mode as TagsMode)}>
        <SelectTrigger className="w-full">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">{t('analytics.filters.tags_mode_all')}</SelectItem>
          <SelectItem value="any">{t('analytics.filters.tags_mode_any')}</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};
